import { createContext, useContext } from 'react';
export const RobotContext = createContext(null);
export function useRobotContext() {
    const context = useContext(RobotContext);
    if (!context) {
        throw new Error('useRobotContext must be used within RobotProvider');
    }
    return context;
}
